import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CreateCombinationsSend } from 'src/oldApp/model/create-combinations-send.model';
import { VwCommissionPanelModel } from 'src/app/model/vw-commission-panel.model';

@Injectable({
  providedIn: 'root'
})
export class VwCommissionPanelService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  getBySchema=(schemaId:number)=> {
    return this.http.get(`${this.url}/VwCommissionPanel/getBySchema/${schemaId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getConfigsTertia=(configs:CreateCombinationsSend)=> { 
    console.log("send data getConfigsTertia "+JSON.stringify(configs));
    return this.http.post(`${this.url}/VwCommissionPanel/getConfiguractionsTercia`, configs)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getConfigsFinancing=(configs:CreateCombinationsSend)=> { 
    console.log("send data getConfigsFinancing "+JSON.stringify(configs));
    return this.http.post(`${this.url}/VwCommissionPanel/getConfiguractionsFinancing`, configs)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  createMissingConfigsTertia=(tableItemsFiltered:VwCommissionPanelModel[], randomTemp:string)=> { 
    console.log(">>> createMissingConfigs >> randomTemp= "+randomTemp);
    return this.http.post(`${this.url}/VwCommissionPanel/createMissingConfigsTercia?randomTemp=${randomTemp}`, tableItemsFiltered)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  createMissingConfigsFinancing=(tableItemsFiltered:VwCommissionPanelModel[], randomTemp:string, savePromotion:number)=> { 
    console.log(">>> createMissingConfigsFinancing >> randomTemp= "+randomTemp);
    return this.http.post(`${this.url}/VwCommissionPanel/createMissingConfigsFinancing?randomTemp=${randomTemp}&savePromotion=${savePromotion}`, tableItemsFiltered)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  updateConfigsTertia=(config:VwCommissionPanelModel, oldSchema:number)=> {
    return this.http.post(`${this.url}/VwCommissionPanel/updateConfigsTercia?oldSchema=${oldSchema}`, config)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  updateConfigsFinancing=(config:VwCommissionPanelModel, oldSchema:number)=> {
    return this.http.post(`${this.url}/VwCommissionPanel/updateConfigsFinancing?oldSchema=${oldSchema}`, config)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  
}
